import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ImageOne from '../Image/image1.png';
import ImageTwo from '../Image/image2.png';
import './Pledge.css';
import logo from '../Image/image.png';
import { v4 as uuidv4 } from 'uuid';

const Pledge = () => {
  const navigate = useNavigate();
  const increasePledgeCountUrl = process.env.REACT_APP_INCREASE_PLEDGE_COUNT;
  const apiKey = process.env.REACT_APP_API_KEY;
  const [pledgeCount, setPledgeCount] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const getSummerOf2025Url = process.env.REACT_APP_GET_SUMMER_2025;
  const handleClick = async () => {
    let userId = localStorage.getItem('userId');
    if (!userId) {
      userId = uuidv4();
      localStorage.setItem('userId', userId);
    }
  
    try {
      const response = await fetch(increasePledgeCountUrl, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "x-api-key": apiKey,
        },
      });
  
      const data = await response.json();
      navigate('/form');
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(getSummerOf2025Url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch Summer of 2025 data");
        }

        const data = await response.json();
        setTotalUsers(data.TotalUsers);
        setPledgeCount(data.pledgeCount);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  
  return (
    <div className="pledge-container">
      <img src={logo} alt="Machaxi Logo" className="pledge-logo" />
        <img src={ImageOne} alt="First Image" className="image-one" />
        <img src={ImageTwo} alt="Second Image" className="image-two" />
        
      <div className="text-box">
        <h1 className='heading1'>Take the Machaxi Summer 2025 Pledge!</h1>
        <h3 className='heading3'>
          Let's make Bengaluru a swimming city! Join the movement where 25% of Bangaloreans learn to swim this summer.
        </h3>
        
        <div className="statistics-sectionn">
          <div className="stat-boxx">
            <p className="stats-numberr">{pledgeCount.toLocaleString()}</p>
            <p className="stats-textt">Bangaloreans Pledged</p>
          </div>
          <div className="stat-dividerr"></div>
          <div className="stat-boxx">
            <p className="stats-numberr">{totalUsers.toLocaleString()}</p>
            <p className="stats-textt">Learned With Us</p>
          </div>
        </div>
        
        <button className='pledge' onClick={handleClick}>I'll Take the Pledge</button>
      </div>

    </div>
  );
};

export default Pledge;
